// hooks/useReceivablePdf.ts

import ReceivablePdfService from "../../services/pdf/receivablePdf.service";
import useLoading from "../useLoading";

export const useReceivablePdf = () => {
    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    /**
     * 📄 Descargar estado de cuenta PDF
     */
    const handleDownloadReceivablePdf = async (
        receivableId: number
    ) => {

        try {
            showLoadingIndicator();

            const { blob, fileName } =
                await ReceivablePdfService.download(
                    receivableId
                );

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download =
                fileName ||
                `estado_cuenta_${receivableId}.pdf`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(
                "❌ Error descargando PDF de cuenta por cobrar:",
                error
            );
        } finally {
            hideLoadingIndicator();
        }
    };

    return {
        handleDownloadReceivablePdf,
    };
};

export default useReceivablePdf;